var $68ce88a369285902$exports = {};
$68ce88a369285902$exports = {
    "backButton": (args)=>`G\xe5 tilbake til ${args.prevMenuButton}`,
    "moreActions": `Flere handlinger`,
    "unavailable": `Utilgjengelig, utvid for detaljer`
};


export {$68ce88a369285902$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
